import React from "react";
// @material-ui/core components
// @mui/icons-material

import Group from "@mui/icons-material/Group";
import Euro from "@mui/icons-material/Euro";
import WatchLater from "@mui/icons-material/WatchLater";
import Code from "@mui/icons-material/Code";
import FormatPaint from "@mui/icons-material/FormatPaint";
import Dashboard from "@mui/icons-material/Dashboard";
import ViewCarousel from "@mui/icons-material/ViewCarousel";

// core components
import GridContainer from "../../../components/Grid/GridContainer.js";
import GridItem from "../../../components/Grid/GridItem.js";
import InfoArea from "../../../components/InfoArea/InfoArea.js";

import featuresStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";

import iphone from "../../../assets/img/sections/iphone.png";
import iphone2 from "../../../assets/img/sections/iphone2.png";
import appstore from "../../../assets/img/appstore.png";
import playstore from "../../../assets/img/playstore.png";

import { getBaseSxStyle } from "../../../utils/getSxStyle.js";
import { Typography, Box } from "@mui/material";


export default function SectionFeatures({ ...rest }) {

  return (
    <div className="cd-section" {...rest}>
      <Box sx={getBaseSxStyle(featuresStyle, ['container'])}>
        {/* Feature 2 START */}
        <Box sx={getBaseSxStyle(featuresStyle, ['features2'])}>
          <GridContainer>
            <GridItem
              sx={getBaseSxStyle(featuresStyle, ['mlAuto', 'mrAuto', 'textCenter'])}
              xs={12}
              sm={12}
              md={12}
            >
              <Typography
                variant="h4"
                sx={getBaseSxStyle(featuresStyle, ['titleCenter'])}
              >
                Preuzmite Smart Part aplikaciju!
              </Typography>
              {/*<h5 className={classes.descriptionCenter}>*/}
              {/*  Vaš digitalni asistent za sve sto Vam je potrebno u vezi*/}
              {/*  Vašeg automobila.*/}
              {/*</h5>*/}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={3} md={3}>

            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
              <a
                href="https://play.google.com/store/apps/details?id=app.smartpart.smartpartbuyerapp"
                target="_blank"
                rel="noreferrer"
              >
                <img src={playstore} alt="..." height={80} />
              </a>
            </GridItem>


            <GridItem xs={12} sm={3} md={3} >
              <a
                href="https://apps.apple.com/us/app/smart-part/id1644323936"
                target="_blank"
                rel="noreferrer"
              >
                <img src={appstore} alt="..." height={81} />
              </a>
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>

            </GridItem>
          </GridContainer>
        </Box>
        {/* Feature 2 END */}
        {/* Feature 3 START */}
        <Box sx={getBaseSxStyle(featuresStyle, ['features3'])}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Box sx={getBaseSxStyle(featuresStyle, ['phoneContainer'])}>
                <img src={iphone} alt="..." />
              </Box>
            </GridItem>
            <GridItem xs={12} sm={6} md={5}>
              <Typography
                variant="h4"
                sx={getBaseSxStyle(featuresStyle, ['title'])}
              >
                Polovni i novi delovi bez muke
              </Typography>

              <InfoArea
                icon={Group}
                title="Stotine partnera"
                description="Svaki zahtev se automatski šalje da adrese naših prodajnih partnera."
                iconColor="secoundary"
              />

              <InfoArea
                icon={Euro}
                title="Ušteda novca"
                description="Partneri šalju svoju najbolju ponudu s obziriom da ne vide ostale ponude koje su vam poslate."
                iconColor="secoundary"
              />

              <InfoArea
                icon={WatchLater}
                title="Ušteda vremena"
                description="Umesto da Vi provedete ceo dan tražeći delove naš sistem to radi u samo nekoliko sekundi umesto vas."
                iconColor="secoundary"
              />
            </GridItem>
          </GridContainer>
        </Box>
        {/* Feature 3 END */}
        {/* Feature 4 START */}
        <Box sx={getBaseSxStyle(featuresStyle, ['features4'])}>
          {/*<GridContainer>*/}
          {/*  <GridItem*/}
          {/*    xs={12}*/}
          {/*    sm={8}*/}
          {/*    md={8}*/}
          {/*    className={*/}
          {/*      classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter*/}
          {/*    }*/}
          {/*  >*/}
          {/*    <h2 className={classes.title}>Your life will be much easier</h2>*/}
          {/*    <h5 className={classes.description}>*/}
          {/*      This is the paragraph where you can write more details about*/}
          {/*      your product. Keep you user engaged by providing meaningful*/}
          {/*      information.*/}
          {/*    </h5>*/}
          {/*  </GridItem>*/}
          {/*</GridContainer>*/}
          <GridContainer>

            <GridItem xs={12} sm={12} md={12} lg={3} sx={getBaseSxStyle(featuresStyle, ['mlAuto'])}>
              <InfoArea
                icon={Code}
                title="Brzo i lako do potrebnog dela"
                description="Na osnovu upita, broja šasije, modela ili fotografije prodavci sami šalju svoje ponude "
                iconColor="info"
              />
              <InfoArea
                icon={FormatPaint}
                title="Značajna ušteda"
                description="Konkurentne cene zbog velikog broja prodavaca. Direktna kupovina od prodavca."
                iconColor="danger"
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={12} lg={4}>
              <Box sx={getBaseSxStyle(featuresStyle, ['phoneContainer'])}>
                <img src={iphone2} alt="..." />
              </Box>
            </GridItem>

            <GridItem xs={12} sm={12} md={12} lg={3} sx={getBaseSxStyle(featuresStyle, ['mlAuto'])}>
              <InfoArea
                icon={Dashboard}
                title="Virtuelni asistent"
                description="Asistencija pri održavanju vozila, odabiru servisa. "
                iconColor="primary"
              />
              <InfoArea
                icon={ViewCarousel}
                title="Sigurna kupovina"
                description="Stručna pomoć pri kupovini, korišćenju aplikacije i odabiru delova. Jednostavno plaćanje."
                iconColor="success"
              />
            </GridItem>

          </GridContainer>
        </Box>
        {/* Feature 4 END */}
      </Box>
      {/*/!* Feature 5 START *!/*/}
      {/*<div*/}
      {/*  className={classes.features5}*/}
      {/*  style={{ backgroundImage: `url(${bg})` }}*/}
      {/*>*/}
      {/*  <GridContainer>*/}
      {/*    <GridItem*/}
      {/*      xs={12}*/}
      {/*      sm={8}*/}
      {/*      md={8}*/}
      {/*      className={*/}
      {/*        classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter*/}
      {/*      }*/}
      {/*    >*/}
      {/*      /!*<h2 className={classes.title}>Your life will be much easier</h2>*!/*/}
      {/*    </GridItem>*/}
      {/*    <div className={classes.container}>*/}
      {/*      <GridContainer className={classes.gridContainer}>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={Code}*/}
      {/*            title="For Developers"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                The moment you use Material Kit, you know you’ve never*/}
      {/*                felt anything like it. With a single use, this powerfull*/}
      {/*                UI Kit lets you do more than ever before.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*            iconColor="info"*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={FormatPaint}*/}
      {/*            title="For Designers"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                Divide details about your product or agency work into*/}
      {/*                parts. Write a few lines about each one. A paragraph*/}
      {/*                describing a feature will be enough.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*            iconColor="danger"*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={Dashboard}*/}
      {/*            title="Material-UI Grid"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                Divide details about your product or agency work into*/}
      {/*                parts. Write a few lines about each one. A paragraph*/}
      {/*                describing a feature will be enough.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*            iconColor="primary"*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*      </GridContainer>*/}
      {/*      <GridContainer className={classes.gridContainer}>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={ViewCarousel}*/}
      {/*            title="Example Pages Included"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                The moment you use Material Kit, you know you’ve never*/}
      {/*                felt anything like it. With a single use, this powerfull*/}
      {/*                UI Kit lets you do more than ever before.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={AccessTime}*/}
      {/*            title="Save Time"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                The moment you use Material Kit, you know you’ve never*/}
      {/*                felt anything like it. With a single use, this powerfull*/}
      {/*                UI Kit lets you do more than ever before.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*        <GridItem xs={12} sm={4} className={classes.gridItem}>*/}
      {/*          <InfoArea*/}
      {/*            vertical*/}
      {/*            className={classes.infoArea5}*/}
      {/*            icon={AttachMoney}*/}
      {/*            title="Save Money"*/}
      {/*            description={*/}
      {/*              <p>*/}
      {/*                The moment you use Material Kit, you know you’ve never*/}
      {/*                felt anything like it. With a single use, this powerfull*/}
      {/*                UI Kit lets you do more than ever before.*/}
      {/*              </p>*/}
      {/*            }*/}
      {/*          />*/}
      {/*        </GridItem>*/}
      {/*      </GridContainer>*/}
      {/*    </div>*/}
      {/*  </GridContainer>*/}
      {/*</div>*/}
      {/*/!* Feature 5 END *!/*/}
    </div>
  );
}
